import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post, put } from './agent';
import allocations from './allocations';
import apiKeys from './apiKeys';
import ai from './ai';
import authProviders from './authProviders';
import bamboohr from './bamboohr';
import billing from './billing';
import businessUnits from './businessUnits';
import clientPayments from './clientPayments';
import clientTags from './clientTags';
import contactTags from './contactTags';
import clients from './clients';
import companies from './companies';
import companySpendTiers from './companySpendTiers';
import companyTypes from './companyTypes';
import contacts from './contacts';
import creditNotes from './creditNotes';
import disciplines from './disciplines';
import exchangeRatePeriods from './exchangeRatePeriods';
import executiveDashboard from './executiveDashboard';
import expenseAdmin from './expenseAdmin';
import expenseCategories from './expenseCategories';
import expenseItems from './expenseItems';
import expenseReports from './expenseReports';
import expensify from './expensify';
import features from './features';
import feedbackItems from './feedbackItems';
import holidaySchedules from './holidaySchedules';
import holidays from './holidays';
import hubspot from './hubspot';
import industries from './industries';
import integrations from './integrations';
import invoiceItems from './invoiceItems';
import invoices from './invoices';
import jobTitles from './jobTitles';
import memberTemplates from './memberTemplates';
import locations from './locations';
import memberCertifications from './memberCertifications';
import memberLevels from './memberLevels';
import memberTags from './memberTags';
import members from './members';
import mfa from './mfa';
import myProfile from './myProfile';
import opportunities from './opportunities';
import opportunityLeadSources from './opportunityLeadSources';
import opportunityStages from './opportunityStages';
import opportunityTags from './opportunityTags';
import opportunityTypes from './opportunityTypes';
import paymentMethods from './paymentMethods';
import paymentTerms from './paymentTerms';
import personalDashboard from './personalDashboard';
import pipelineActivities from './pipelineActivities';
import pipelineActivityTypes from './pipelineActivityTypes';
import practices from './practices';
import productUpdates from './productUpdates';
import projectGroups from './projectGroups';
import projectMemberRoles from './projectMemberRoles';
import projectMembers from './projectMembers';
import projectTags from './projectTags';
import projectTaskCategories from './projectTaskCategories';
import projectTaskTags from './projectTaskTags';
import projectTaskTemplates from './projectTaskTemplates';
import projectTasks from './projectTasks';
import projectSettings from './projectSettings';
import projectTypes from './projectTypes';
import projects from './projects';
import purchaseOrders from './purchaseOrders';
import qbd from './qbd';
import qbo from './qbo';
import ratings from './ratings';
import reports from './reports';
import resourcePlaceholders from './resourcePlaceholders';
import rippling from './rippling';
import salesforce from './salesforce';
import search from './search';
import securityRoles from './securityRoles';
import skills from './skills';
import taxRates from './taxRates';
import timeAdmin from './timeAdmin';
import timeEntries from './timeEntries';
import timeOffTypes from './timeOffTypes';
import timesheets from './timesheets';
import timesheetAttestations from './timesheetAttestations';
import weekFiles from './weekFiles';
import workspaceRoles from './workspaceRoles';
import xero from './xero';
import xeroExport from './xeroExport';
import opportunityPipelines from './opportunityPipelines';

function workspaces(workspaceId = '') {
  const url = _(['/www/workspaces', workspaceId]).compact().join('/');

  return {
    get: () => get(url),
    select: () => post(url),
    lastAccessed: () => get(url.concat('/last-accessed')),
    trialRequest: () => post(url.concat('/trial-request')),
    create: (body) => post(url, body),
    patch: (body) => patch(url, body),
    setImage: (file) =>
      put(url.concat('/image'), file?.bytes, file ? { headers: { 'Content-Type': file?.type } } : undefined),
    setInvoiceImage: (file) =>
      put(url.concat('/invoice-image'), file?.bytes, file ? { headers: { 'Content-Type': file?.type } } : undefined),
    getProjectCodeSettings: () => get(url.concat('/project-code')),
    updateProjectCodeSettings: (body) => patch(url.concat('/project-code'), body),
    getClientCodeSettings: () => get(url.concat('/client-code')),
    updateClientCodeSettings: (body) => patch(url.concat('/client-code'), body),
    getTaskCodeSettings: () => get(url.concat('/task-code')),
    updateTaskCodeSettings: (body) => patch(url.concat('/task-code'), body),
    delete: ({ name }) => del(url, { data: { name } }),
    projectTasks: projectTasks(url.concat('/project-tasks')),
    projectMembers: projectMembers(url.concat('/project-members')),
    members: members(url),
    myProfile: myProfile(url),
    mfa: mfa(url),
    clients: clients(url),
    companies: companies(url),
    companySpendTiers: companySpendTiers(url),
    companyTypes: companyTypes(url),
    contacts: contacts(url),
    projects: projects(url),
    projectSettings: projectSettings(url),
    purchaseOrders: purchaseOrders(url),
    invoiceItems: invoiceItems(url),
    jobTitles: jobTitles(url),
    memberLevels: memberLevels(url),
    memberTemplates: memberTemplates(url),
    projectTypes: projectTypes(url),
    clientTags: clientTags(url),
    contactTags: contactTags(url),
    disciplines: disciplines(url),
    holidays: holidays(url),
    holidaySchedules: holidaySchedules(url),
    industries: industries(url),
    locations: locations(url),
    memberTags: memberTags(url),
    memberCertifications: memberCertifications(url),
    skills: skills(url),
    paymentMethods: paymentMethods(url),
    paymentTerms: paymentTerms(url),
    practices: practices(url),
    opportunityLeadSources: opportunityLeadSources(url),
    opportunityPipelines: opportunityPipelines(url),
    opportunityTypes: opportunityTypes(url),
    pipelineActivities: pipelineActivities(url),
    pipelineActivityTypes: pipelineActivityTypes(url),
    opportunityStages: opportunityStages(url),
    opportunities: opportunities(url),
    opportunityTags: opportunityTags(url),
    projectTags: projectTags(url),
    resourcePlaceholders: resourcePlaceholders(url),
    workspaceRoles: workspaceRoles(url),
    securityRoles: securityRoles(url),
    integrations: integrations(url),
    projectTaskCategories: projectTaskCategories(url),
    projectTaskTags: projectTaskTags(url),
    projectTaskTemplates: projectTaskTemplates(url),
    taxRates: taxRates(url),
    timesheets: timesheets(url),
    timesheetAttestations: timesheetAttestations(url),
    timeEntries: timeEntries(url),
    timeOffTypes: timeOffTypes(url),
    projectMemberRoles: projectMemberRoles(url.concat('/project-member-roles')),
    expenseReports: expenseReports(url.concat('/expense-reports')),
    expenseAdmin: expenseAdmin(url.concat('/expense-admin')),
    expenseItems: expenseItems(url.concat('/expense-items')),
    expenseCategories: expenseCategories(url),
    personalDashboard: personalDashboard(url),
    search: search(url),
    invoices: invoices(url),
    businessUnits: businessUnits(url),
    clientPayments: clientPayments(url),
    creditNotes: creditNotes(url),
    timeAdmin: timeAdmin(url),
    ratings: ratings(url),
    reports: reports(url),
    allocations: allocations(url),
    qbd: qbd(url),
    qbo: qbo.workspace(url),
    billing: billing.workspace(url),
    xero: xero.workspace(url),
    xeroExport: xeroExport(url),
    rippling: rippling.workspace(url),
    salesforce: salesforce.workspace(url),
    hubspot: hubspot.workspace(url),
    apiKeys: apiKeys(url),
    expensify: expensify(url),
    bamboohr: bamboohr.workspace(url),
    weekFiles: weekFiles(url),
    features: features(url),
    feedbackItems: feedbackItems(url),
    timeApproval: {
      get: () => get(url.concat('/time-approval')),
      update: (body) => put(url.concat('/time-approval'), body),
    },
    expenseApproval: {
      get: () => get(url.concat('/expense-approval')),
      update: (body) => put(url.concat('/expense-approval'), body),
    },
    authProviders: authProviders(url),
    executiveDashboard: executiveDashboard(url),
    removeSampleData: () => del(url.concat('/sample-data')),
    exchangeRatePeriods: exchangeRatePeriods(url),
    productUpdates: productUpdates(url),
    projectGroups: projectGroups(url),
    exchangeRates: {
      convert: (query = {}) => get(url.concat('/exchange-rates/convert').concat(new QueryString(query).toString(true))),
    },
    assistant: () => ai(url),
    ai: () => ai(url),
  };
}

export default workspaces;
